export const formatPersonName = (value, fallback = "User") => {
  const name = String(value || "")
    .trim()
    .replace(/\s+/g, " ");
  if (!name || name.includes("@")) return fallback;

  return name
    .toLocaleLowerCase()
    .replace(/(^|[\s'-])\p{L}/gu, (letter) => letter.toLocaleUpperCase());
};